import '@babel/polyfill';
import 'picturefill';
import 'custom-event-polyfill';

import './polyfills';
import './header';
import './ageGate';
import './forgot-password';
import './instant-page';
import './newsletterForm';
import './nicotineWarning';
import './sign-in';
import './store-locale-selector';
import './cookie-policy';
import 'common/ujs/all';
import 'pages/tracking-links';
import segment from 'common/segment';
import { init as monetateInit } from 'common/integrations/monetate';

import GDPRBanner from './gdpr-banner';

const gdprBanner = new GDPRBanner();
const geo = gon.geo_location;
const storeCode = gon.current_store.code;
gdprBanner.showGdprBannerIfNecessary(geo, storeCode);
segment.initialize();
monetateInit();
